// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Banner-Carousel_wrapper__1ysZW","slide":"Banner-Carousel_slide__263sf"};